import { FeatureEnabledV2, SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_UPDATED, USER_LOGGED_IN_UPDATED, USER_LOGIN_TIME_EVENT, Feature } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions';

var PanicBarComponent = /** @class */ (function (_super) {
    __extends(PanicBarComponent, _super);
    function PanicBarComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.agcoBarShown = false;
        _this.isLoggedIn = false;
        _this.userLoginTime = 0;
        _this.currentJurisdiction = null;
        _this.jurisdictionSubscription = null;
        _this.loggedInSubscription = null;
        return _this;
    }
    Object.defineProperty(PanicBarComponent.prototype, "isLOTBA", {
        get: function () {
            return this.currentJurisdiction === Jurisdiction.LOTBA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PanicBarComponent.prototype, "isSGA", {
        get: function () {
            return this.currentJurisdiction === Jurisdiction.SGA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PanicBarComponent.prototype, "isAGCO", {
        get: function () {
            return this.currentJurisdiction === Jurisdiction.AGCO;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PanicBarComponent.prototype, "isEMTA", {
        get: function () {
            return this.currentJurisdiction === Jurisdiction.EMTA;
        },
        enumerable: false,
        configurable: true
    });
    PanicBarComponent.prototype.created = function () {
        var _this = this;
        this.jurisdictionSubscription = window.eventBus.subscribe(USER_JURISDICTION_UPDATED, function (event) {
            _this.currentJurisdiction = event.payload;
        }, { replay: true });
        this.loggedInSubscription = window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function (e) {
            var _a;
            _this.isLoggedIn = (_a = e.payload) !== null && _a !== void 0 ? _a : false;
        }, { replay: true });
    };
    PanicBarComponent.prototype.destroyed = function () {
        var _a, _b;
        (_a = this.jurisdictionSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.loggedInSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    };
    PanicBarComponent.prototype.getLoginTime = function (isLoggedIn) {
        var user = magic.session.getUser();
        if (!isLoggedIn || !user) {
            this.userLoginTime = 0;
            return;
        }
        var currentTime = Date.now();
        this.userLoginTime =
            user.lastVisit > currentTime ? currentTime : user.lastVisit;
        window.eventBus.publish(USER_LOGIN_TIME_EVENT, this.userLoginTime);
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.AGCO_TOP_BAR,
        }),
        __metadata("design:type", Object)
    ], PanicBarComponent.prototype, "agcoBarShown", void 0);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PanicBarComponent.prototype, "getLoginTime", null);
    PanicBarComponent = __decorate([
        Component({
            name: 'panic-bar',
        })
    ], PanicBarComponent);
    return PanicBarComponent;
}(Mixins(MagicConfigMixin)));

export default PanicBarComponent;
